import React, { useEffect, useState } from 'react';
import axios from 'axios';
import httpInjectorService from 'services/http-injector.service';
import { useParams } from 'react-router-dom';
import { LinkOutlined } from '@ant-design/icons';
import { Popconfirm } from 'antd';
import { toast } from 'react-toastify';


const WebLinkList = ({ work_id, work_type, refreshFlag }) => {
  
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hoveredId, setHoveredId] = useState(null);
  const project_id = useParams();
  const PROJECTID=project_id.id || project_id.projectId

  const fetchLinks = async () => {
    const queryparams = `?project_id=${PROJECTID}&work_type=${work_type}&work_id=${work_id}`;
    try {
      setLoading(true);
      const res = await httpInjectorService.getWebLink(queryparams);
      setLinks(res.data || []);
    } catch (err) {
      console.error('Error fetching links:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLinks();
  }, [refreshFlag]);

  const handleDelete = async (id) => {
   
    const data = {
      project_id: project_id.id,
      work_type: work_type,
      work_id: work_id,
      weblink_id:id
    };
    try {
      let response = await httpInjectorService.deleteWebLink(data);
      if (response.status === 'success') {
        toast.success(response.message, {
                 position: 'top-right',
                 autoClose: 3000,
               }); 
        fetchLinks();
      } else {
         toast.error(response.message, {
                  position: 'top-right',
                  autoClose: 3000,
                });
      }
    } catch (err) {
      console.error('Delete failed:', err);
    }
  };

  
  if (!loading && links.length === 0) {
    return null;
  }

  return (
    <div
      style={{
    width: '100%',          // take full available space
    maxWidth: '620px',      // but don’t exceed 620px
    background: '#ffffff',
    padding: '12px',
    color: '#000',
    fontFamily: 'Arial',
    marginTop: '20px',
    boxSizing: 'border-box', // prevents overflow due to padding
  }}
    >
      <div style={{ marginBottom: '10px', fontSize: '16px' }}>Web links</div>

      {loading ? (
        <p></p>
      ) : (
        links.map((item) => (
          <div
            key={item.weblink_id}
            onMouseEnter={() => setHoveredId(item.weblink_id)}
            onMouseLeave={() => setHoveredId(null)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '6px',
              background: '#fff',
              marginBottom: '8px',
              borderRadius: '6px',
              border: '1px solid #e0e0e0',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                flex: 1,
                minWidth: 0,
              }}
            >
              <span>
                <LinkOutlined />
              </span>

              <a
                href={item.web_link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#333', textDecoration: 'none' }}
                onMouseOver={(e) => {
                  e.target.style.color = '#1890ff';
                  e.target.style.textDecoration = 'underline';
                }}
                onMouseOut={(e) => {
                  e.target.style.color = '#333';
                  e.target.style.textDecoration = 'none';
                }}
              >
                {item.description || item.web_link}
              </a>
            </div>

         
  <button
  onClick={()=>handleDelete(item.weblink_id)}
    style={{
      background: "transparent",
      border: "none",
      color: "#888",
      cursor: "pointer",
      fontSize: "16px",
      visibility:
        hoveredId === item.weblink_id ? "visible" : "hidden",
    }}
  >
    ✕
  </button>

          </div>
        ))
      )}
    </div>
  );
};

export default WebLinkList;
